import React, { Fragment } from "react";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import { isEqual } from "lodash/lang";
import DataGrid from "../../../dataGrid";
import GridConfig from "./gridConfig";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import StatusBar from "../../../dataGrid/StatusBar";
import Events from "../../../../utilities/EventEmitter";
import { getFilteredData } from "../../../common/filterUtilities";
import appConstants from "../../../../appConstants";
import { getCustomerManagementData } from "../../Common/Geocoding/utils";
import GeoCodingModal from "../../Common/Geocoding/GeoCodingModal";
import { getSpecialNeeds } from "../../utils";

@inject("IBPlanningStore")
@observer
class Shippers extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.state = {
      quickFilterText: "",
      geoCodeCustomer: null,
      shipperData: null,
      terminalId: this.props.userData.userProfile.terminal.id,
      quickFilter: null,
    };
    this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
    this.gridContext = {
      specialNeedsOptions: getSpecialNeeds(this.serviceLevelList),
    };
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.selectedShippers = [];
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.glEventHub.on(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.on(
      `${this.gridHeaderId}_geocode`,
      this.onGeocodeCustomer
    );
    Events.on("updateShipper", this.updateShipper);
    this.props.glEventHub.on(
      "updateQuickFilter",
      this.updateShipperQuickFilter
    );
    this.getShipperData();
    this.props.glEventHub.on(
      `activeTabSwitched_${appConstants.gridNames.ShipperGrid}`,
      this.onSelectionChanged
    );
    this.autorunPriorityShipmentList = autorun(() => {
      if (
        !isEqual(
          this.serviceLevelList,
          this.props.IBPlanningStore.serviceLevelList
        )
      ) {
        this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
        this.gridContext = {
          specialNeedsOptions: getSpecialNeeds(this.serviceLevelList),
        };
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.glEventHub.off(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.off(
      `${this.gridHeaderId}_geocode`,
      this.onGeocodeCustomer
    );
    Events.off("updateShipper", this.updateShipper);
    this.props.glEventHub.off(
      "updateQuickFilter",
      this.updateShipperQuickFilter
    );
    this.props.glEventHub.off(
      `activeTabSwitched_${appConstants.gridNames.ShipperGrid}`,
      this.onSelectionChanged
    );
    this.autorunPriorityShipmentList?.();
  }

  updateShipperQuickFilter = (quickFilterData) => {
    if (
      quickFilterData.filterName ===
      appConstants.CUSTOMER_MANAGEMENT_QUICKFILTER_NAMES.SHIPPER_GRID
    ) {
      this.setState({
        quickFilter: quickFilterData.eventData,
      });
    }
  };

  onGeocodeCustomer = () => {
    const selectedShippers = this.gridApi.getSelectedRows();
    if (!selectedShippers.length) {
      return;
    }

    this.setState({
      geoCodeCustomer: {
        ...getCustomerManagementData(
          selectedShippers[0],
          appConstants.CUSTOMER_TYPE.PICKUP
        ),
        proId: "",
      },
    });
  };

  updateShipper = (updatedCustomer) => {
    const { shipperData } = this.state;
    updatedCustomer.forEach((customer) => {
      const index = shipperData.findIndex((c) => c.code === customer.code);
      shipperData[index] = customer;
    });
    this.setState({
      shipperData,
    });
  };

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.userData.userProfile.terminal.id !== state.terminalId) {
      return {
        terminalId: nextProps.userData.userProfile.terminal.id,
        shipperData: null,
      };
    }
    return null;
  }

  runCommand = (command, data) => {
    if (command === "openGeoCodeModel") {
      this.setState({
        geoCodeCustomer: getCustomerManagementData(
          data,
          appConstants.CUSTOMER_TYPE.PICKUP
        ),
      });
    }
  };

  closeGeocodeModal = (hasDataChanged = false) => {
    if (hasDataChanged) {
      Events.emit("updateCustomerData", this.state.geoCodeCustomer.code);
    }
    this.setState({
      geoCodeCustomer: null,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.userProfile.terminal.id !==
      this.props.userData.userProfile.terminal.id
    ) {
      this.getShipperData();
    }
  }

  getShipperData = () => {
    this.setState({
      shipperData: null,
    });

    getDataWithQueryString(
      "GetCustomerDetail",
      `terminalId=${this.props.userData.userProfile.terminal.id}&shouldOnlyReturnShippers=true`
    ).then((response) => {
      if (!this._isMounted) {
        return;
      }
      if (response.status === 200) {
        this.setState({
          shipperData: response?.data ?? [],
        });
      } else {
        this.setState({
          shipperData: [],
        });
      }
    });
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
  };

  onSelectionChanged = () => {
    if(this.props.glContainer.tab.isActive){
    this.selectedShippers = this.gridApi.getSelectedRows();
    this.props.glEventHub.emit("customerSelectedonGrid", {
      selectedCustomers: this.selectedShippers,
      stopType: appConstants.ROUTE_STOP_TYPES.PU,
    });
  }
  };

  onDoubleClicked = (params) => {
    Events.emit(
      "OpenEditCustomerDialog",
      params?.node?.data.code,
      appConstants.CUSTOMER_TYPE.PICKUP
    );
  };

  constructStatusBar = (shipperList) => {
    return [
      {
        label: `${shipperList.length} Shippers`,
      },
    ];
  };

  onRowDataChanged = () => {
    if (!this.state.shipperData) {
      this.gridApi?.hideOverlay();
      this.gridApi?.showLoadingOverlay();
    } else {
      this.gridApi?.hideOverlay();
    }
    const selectedCustomerCodes = this.selectedShippers.map(
      (customer) => customer.code
    );
    this.gridApi.forEachNode?.((node) => {
      if (selectedCustomerCodes.includes(node.data.code)) {
        node.setSelected(true, false, true); // props are isSelected, clearOtherSelection, suppressFinishActions
      } else {
        // disabling supress finish actions calls onSelectionChanged event for each selection
        node.setSelected(false, false, true); // but we want single call of onSelectionChanged for multiselection , behaviour observed through user action
      } // so we suppress the call from setSelected and call it explicitly after loop completes
    });
    this.gridApi.dispatchEvent({
      type: "selectionChanged",
      api: this.gridApi,
    });
  };

  render() {
    const shipperData = this.state.quickFilter
      ? getFilteredData(
          this.state.shipperData ?? [],
          this.state.quickFilter,
          new Date()
        )
      : this.state.shipperData?.slice();
    return (
      <Fragment>
        <DataGrid
          key={this.props.userData.userProfile.terminal.id}
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          enableFilter={this.gridConfig.config.enableFilter}
          enableSorting={this.gridConfig.config.enableSorting}
          rowData={shipperData}
          onRowDataChanged={this.onRowDataChanged}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged}
          layoutContainer={this.props.glContainer}
          quickFilterText={this.state.quickFilterText}
          onCellDoubleClicked={this.onDoubleClicked}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
              filterGridData={this.updateGridData}
            />
          )}
          context={this.gridContext}
        />
        {this.state.geoCodeCustomer && (
          <GeoCodingModal
            customer={this.state.geoCodeCustomer}
            userData={this.props.userData.userProfile}
            close={this.closeGeocodeModal}
          />
        )}
      </Fragment>
    );
  }
}

export default compose(withUserProfile, withSnackbar)(Shippers);
